// src/config/products.js
//
// Product catalogue + SKU parsing, extracted for the demo flavor (the
// "Phase 2: extract to /src/config/products.js" TODO in FoamFlow.js).
// Values mirror the PRODUCTS map in FoamFlow.js / ProductRegistration.js —
// when FoamFlow migrates to importing from here, delete its local copy.

export const PRODUCTS = {
  GLIDE: {
    name: 'Glide',
    sizes: ['55', '66', '77', '88', '99', '111'],
    image: 'https://cdn.shopify.com/s/files/1/0642/2799/9902/files/792438d8-c3cd-41e2-bc20-47d348a665e8.png?v=1739836117',
  },
  ROLLINGWAKA: {
    name: 'Rolling Waka',
    sizes: ['Medium', 'Large'],
    image: 'https://cdn.shopify.com/s/files/1/0642/2799/9902/files/RollingWakaHumanShadow.png?v=1739480879',
  },
  GLIDEDAYBAG: {
    name: 'Glide Day Bag',
    sizes: ['55', '66', '77', '88', '99', '111'],
    image: 'https://cdn.shopify.com/s/files/1/0642/2799/9902/files/WakaGlideDaybag.png?v=1740086016',
  },
};

// Parse a SKU like "GLIDE-88-V2-A0427" into a product object.
export function parseSku(sku) {
  if (!sku) return null;
  const parts = sku.toUpperCase().split('-');
  const familyKey = parts[0];
  const productDef = PRODUCTS[familyKey];
  if (!productDef) return null;
  return {
    sku: sku.toUpperCase(),
    family: familyKey,
    productName: productDef.name,
    size: parts[1] || '',
    version: parts[2] || '',
    serial: parts[3] || '',
    image: productDef.image,
    caption: [parts[3], parts[2], parts[1] ? `${parts[1]} L` : ''].filter(Boolean).join(' · '),
    name: `${productDef.name.toUpperCase()} ${parts[1] || ''}`.trim(),
  };
}
